import { USER_STATE, SOFTPHONES_KEY, DRAGGABLE_WINDOWS, STATES_INTEGRATION, STATE_TO_PLAY_END_AUDIO } from '../constants';
import { aclaracion, agua, banio, naBreak, cafe, cambio, comida, conCliente, junta, sistemas, conSupervisor, dinero, duda, otro, queja, salud } from '../Images/NoAvailableIconsSVG';

let instance = null;

export class SingletonSharedData {
	constructor() {
		if (!instance) {
			instance = this;
		}
		this.volumeSpeaker = 50;
		this.volumeMic = 50;
		this.currentSoftPhone = SOFTPHONES_KEY.WebRTC;
		this.problemInManualCall = false;
		this.ipAddress = '';
		this.ipAddressAPI = '';
		this.ipIntegration = '';
		this.chatsList = {};
		this.integrationPort = '';
		this.integrationServer = '';
		this.integrationAutorun = false;
		this.integrationIconActived = false;
		this.integrationConnectionStatus = STATES_INTEGRATION.disconnecting;
		this.integrationLog = [];
		this.chatListNotReaded = {};
		this.currentTimeInState = 0;
		this.barExpanded = false;
		this.isLogged = false;
		this.manualCallTime = 0;
		this.XferTime = 0;
		this.chatWindowOpen = false;
		this.supervisorChat = '';
		this.textToSendSupervisorChat = '';
		this.currentCallTime = '';
		this.currentCallMarks = [];
		this.extraCallsConference = 0;
		this.hasUnifiedMessage = false;
		this.telephoneCallBack = '';
		this.currentState = 'logout';
		this.assistedTransferState = '';
		this.requestTimeout = 60000;
		this.isPreview = false;
		this.isAssisted = false;
		this.selectedConversationId = 0;
		this.prevNotificationError = true;
		(this.dataObject = {}), (this.dataPreviewPro = {}), (this.callDataPreviewPro = {}), (this.isCallPreview = false), (this.isInactiveState = false);
		(this.isTabFocused = true),
			(this.iconsNA = {
				1: naBreak,
				2: banio,
				3: conCliente,
				4: conSupervisor,
				5: aclaracion,
				6: junta,
				7: comida,
				8: sistemas,
				9: cafe,
				10: agua,
				11: otro,
				12: duda,
				13: salud,
				14: queja,
				15: dinero,
				16: cambio
			});

		this.windowsOpened = {
			[DRAGGABLE_WINDOWS.MANUAL_CALL]: false,
			[DRAGGABLE_WINDOWS.NO_AVAILABLE]: false,
			[DRAGGABLE_WINDOWS.SUPERVISOR_CHAT]: false,
			[DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD]: false,
			[DRAGGABLE_WINDOWS.CALL_RECORD]: false
		};
		//TheFollowing array helps identify the components to be closed when another expanded component is open
		this.expandedWindowsToClose = {
			[DRAGGABLE_WINDOWS.NO_AVAILABLE]: [DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD],
			[DRAGGABLE_WINDOWS.SUPERVISOR_CHAT]: [DRAGGABLE_WINDOWS.NO_AVAILABLE, DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD],
			[DRAGGABLE_WINDOWS.NO_AVAILABLE_RECORD]: [DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, DRAGGABLE_WINDOWS.NO_AVAILABLE]
		};
		this.windowExpandedActive = DRAGGABLE_WINDOWS.NONE;
		this.isIntegration = false;
		this.isIntegrationManualCall = false;
		this.windowChatOpen = false;
		this.secureConnection = false;
		this.callOutCampaigns = null;
		this.versionAgentKolob = '';
		this.country = '';
		this.campID = '';
		this.focusTel = false;
		this.isRated = false;
		this.isPendingMessage = false;
		this.audioNotificationCallStart = null;
		this.audioNotificationCallEnd = null;
		this.isHangedUpByAgent = STATE_TO_PLAY_END_AUDIO.LOADING;
		this.odbcExternalCall = false;
		this.AllowMarksPermission = true;
		this.callIcon=null;
		this.integrationCallData=null;
		this.sendDataOncallout=false;
		this.aniList=[];
		this.isANIListEmpty=false;
		this.agentList=[];
		this.doConnectCall=true
		return instance;
	}

	setAllowMarksPermission(value){
		this.AllowMarksPermission = value;
	}

	getAllowMarksPermission(){
		return this.AllowMarksPermission;
	}

	setOdbcExternalCall(value){
		this.odbcExternalCall = value;
	}

	getOdbcExternalCall(){
		return this.odbcExternalCall;
	}

	setIsTabFocused(value) {
		this.isTabFocused = value;
	}
	getIsTabFocused() {
		return this.isTabFocused;
	}
	setIsRated(value) {
		this.isRated = value;
	}
	getIsRated() {
		return this.isRated;
	}
	setVolumeSpeaker(volumeSpeaker) {
		this.volumeSpeaker = volumeSpeaker;
	}
	getVolumeSpeaker() {
		return this.volumeSpeaker;
	}
	setVolumeMic(volumeMic) {
		this.volumeMic = volumeMic;
	}
	getVolumeMic() {
		return this.volumeMic;
	}
	setIPIntegration(ipAddress) {
		this.ipIntegration = ipAddress;
	}
	getIPIntegration() {
		return this.ipAddress;
	}
	setIPAddress(ipAddress) {
		this.ipAddress = ipAddress;
	}
	getIPAddress() {
		return this.ipAddress;
	}
	setCampaingID(campID) {
		this.campID = campID;
	}
	getCampaingID() {
		return this.campID;
	}

	setIPfromAPI(ipAddressAPI) {
		this.ipAddressAPI = ipAddressAPI;
	}
	getIPfromAPI() {
		return this.ipAddressAPI;
	}
	getCurrentState() {
		return this.currentState;
	}
	setCurrentState(currentState) {
		this.currentState = currentState;
	}
	setIsIntegration() {
		this.isIntegration = !this.isIntegration;
	}
	getIsIntegration() {
		return this.isIntegration;
	}
	setIsIntegrationManualCall() {
		this.isIntegrationManualCall = !this.isIntegrationManualCall;
	}
	getIsIntegrationManualCall() {
		return this.isIntegrationManualCall;
	}
	setIntegrationConnectionStatus(newStatus) {
		this.integrationConnectionStatus = newStatus;
	}
	getIntegrationConnectionStatus() {
		return this.integrationConnectionStatus;
	}
	setIntegrationConfiguration(integrations) {
		var integrationData = integrations.split('|');
		// IP|WEBSOCKETPORT|SOCKETPORT|AUTORUN|ICONACTIVED
		this.integrationPort = this.secureConnection ? integrationData[2] : integrationData[1];

		console.log('readhostname integrationPort', this.integrationPort);
		this.integrationIconActived = integrationData[4] === '1';
		if (integrationData[4] === '1') {
			this.integrationAutorun = integrationData[3] === '1';
		}
	}
	getIntegrationServer() {
		return this.integrationServer;
	}
	getIntegrationPort() {
		return this.integrationPort;
	}
	getIntegrationAutorun() {
		return this.integrationAutorun;
	}
	getintegrationIconActived() {
		return this.integrationIconActived;
	}
	getIntegrationLog() {
		return this.integrationLog;
	}
	setIntegrationLog(updatedLog) {
		this.integrationLog = updatedLog;
	}
	setWindowExpandedActive(windowTag) {
		this.windowExpandedActive = windowTag;
	}
	getWindowExpandedActive() {
		return this.windowExpandedActive;
	}
	setStateWindow(windowTag, windowState) {
		if (!windowState) {
			this.windowsOpened[windowTag] = windowState;
		} else {
			this.windowsOpened[windowTag] = !this.windowsOpened[windowTag];
		}
	}
	getExpandedWindowsToClose(newUpenWindow) {
		return this.expandedWindowsToClose[newUpenWindow];
	}
	getStateWindow(windowTag) {
		return this.windowsOpened[windowTag];
	}
	setPhoneCallBack(phone) {
		this.telephoneCallBack = phone;
	}
	getPhoneCallBack() {
		return this.telephoneCallBack;
	}
	setSoftPhone(softPhone) {
		this.currentSoftPhone = softPhone;
	}

	getSoftPhone() {
		return this.currentSoftPhone;
	}

	setLogged(logged) {
		this.isLogged = logged;
	}

	getLogged() {
		return this.isLogged;
	}

	setUserData(user) {
		this.user = user;
		this.setDataPreviewPro(user.DialingMode, user.AllowChangeDialingMode);
	}

	setPhoneNumber(phoneNumber) {
		this.phoneNumber = phoneNumber;
	}
	setParameters(parameters) {
		this.parameters = parameters;
	}

	setPermissions(permissions) {
		this.permissions = {
			...permissions
		};
	}

	setGeneralPermissions(generalPermissions) {
		this.generalPermissions = generalPermissions;
	}
	setCallOutCampaigns(callOutCampaigns) {
		this.callOutCampaigns = callOutCampaigns;
	}
	setANIListCampaign(aniList){
		this.aniList = aniList;
	}
	setIsANIListEmpty(isANIListEmpty){
		this.isANIListEmpty = isANIListEmpty;
	}
	setCurrentTimeInState(currentTime) {
		this.currentTimeInState = currentTime;
	}

	getUserData() {
		return this.user;
	}

	getPhoneNumber() {
		return this.phoneNumber;
	}

	getParameters() {
		return this.parameters;
	}

	getPermissions() {
		return this.permissions;
	}

	getGeneralPermissions() {
		return this.generalPermissions;
	}
	isInCallState(userState) {
		if (userState === USER_STATE.DIALOG || userState === USER_STATE.WRAPUP || userState === USER_STATE.ASSISTED || (this.isLogged && userState === USER_STATE.OTHER)) {
			return true;
		}
		return false;
	}

	setBarExpandedShowed(barExpanded) {
		this.barExpanded = barExpanded;
	}

	isBarExpandedSowed() {
		return this.barExpanded;
	}

	getIconNoAvailable(frame) {
		return this.iconsNA[frame];
	}

	//SUPERVISOR LIST FUNCTIONS
	setSupervisorList(supervisorList) {
		this.supervisorList = supervisorList;
		this.supervisorObserver(supervisorList);
	}
	observerSupervisor(supervisorObserver) {
		this.supervisorObserver = supervisorObserver;
	}
	getSupervisorList() {
		return this.supervisorList;
	}
	setChatWindowOpen(open) {
		this.chatWindowOpen = open;
	}
	getChatWindowOpen() {
		return this.chatWindowOpen;
	}
	clearChatList() {
		this.chatsList = {};
	}
	setObjectChat(object, chatList) {
		if (!this.chatsList[chatList]) {
			this.chatsList[chatList] = [];
		}
		this.chatsList[chatList].push(object);
	}
	getChatList(chatList) {
		if (typeof this.chatsList[chatList] === 'undefined') {
			return [];
		}
		return this.chatsList[chatList];
	}
	setNewNotificationChat(chatList, resetChat = false) {
		if (!this.chatListNotReaded[chatList]) {
			this.chatListNotReaded[chatList] = 1;
		} else {
			this.chatListNotReaded[chatList]++;
		}
		if (resetChat) {
			this.chatListNotReaded[chatList] = 0;
		}
	}
	getNotificationChat(chatList) {
		return this.chatListNotReaded[chatList];
	}
	setCurrentSuperVisor(supervisor) {
		this.supervisorChat = supervisor;
	}
	getCurrentSuperVisor() {
		return this.supervisorChat;
	}
	setTextToSend(textToSend) {
		this.textToSendSupervisorChat = textToSend;
	}
	getTextToSend() {
		return this.textToSendSupervisorChat;
	}
	setCurrentCallTime(currentCallTime) {
		this.currentCallTime = currentCallTime;
	}
	getCurrentCallTime() {
		return this.currentCallTime;
	}
	setCurrentCallMarks(currentCallMarks) {
		this.currentCallMarks = currentCallMarks;
	}
	getCurrentCallMarks() {
		return this.currentCallMarks;
	}
	setManualCallTime(time) {
		this.manualCallTime = time;
	}
	getManualCallTime() {
		return this.manualCallTime;
	}
	setXferTime(time) {
		this.XferTime = time;
	}
	getXferTime() {
		return this.XferTime;
	}
	setConferenceCallID(callID) {
		this.conferenceCallID = callID;
	}
	getConferenceCallID() {
		return this.conferenceCallID;
	}
	setConferenceHangUpOther(callID) {
		this.conferenceHangUpOther = callID;
	}
	getConferenceHangUpOther() {
		return this.conferenceHangUpOther;
	}
	addCallConference() {
		this.extraCallsConference++;
	}
	substractCallConference() {
		this.extraCallsConference--;
	}
	getextraCallsConference() {
		return this.extraCallsConference;
	}
	setCallConferencetoZero() {
		this.extraCallsConference = 0;
	}
	setConferenceNewNumber(newNumber) {
		this.conferenceNewNumber = newNumber;
	}
	getConferenceNewNumber() {
		return this.conferenceNewNumber;
	}
	setWindowChatOpen(chatOpen) {
		this.windowChatOpen = chatOpen;
	}
	getWindowChatOpen(chatOpen) {
		return this.windowChatOpen;
	}
	getSecureConnection() {
		return this.secureConnection;
	}
	setSecureConnection(secureConnection) {
		this.secureConnection = secureConnection;
	}
	setVersionAgent(versionAgentKolob) {
		this.versionAgentKolob = versionAgentKolob;
	}
	getVersionAgent() {
		return this.versionAgentKolob;
	}
	setCountry(country) {
		this.country = country;
	}
	getCountry() {
		return this.country;
	}
	setFocusTel(focusTel) {
		this.focusTel = focusTel;
	}
	getFocusTel() {
		return this.focusTel;
	}
	getAssistedTransferCurrentState() {
		return this.assistedTransferState;
	}
	setAssistedTransferCurrentState(assistedTransferState) {
		this.assistedTransferState = assistedTransferState;
	}
	setRequestTimeout(requestTimeout) {
		let castNumber = parseInt(requestTimeout, 10);
		if (Number.isInteger(castNumber)) {
			this.requestTimeout = castNumber;
		}
	}
	getRequestTimeout() {
		return this.requestTimeout;
	}
	setIsAssisted(isAssisted) {
		this.isAssisted = isAssisted;
	}
	getIsAssisted() {
		return this.isAssisted;
	}
	setDataAssistedCall(dataCall) {
		this.dataObject = {
			campaingName: dataCall.CampaignName,
			iconCampaing: dataCall.GraphId,
			calKey: dataCall.CallKey,
			Id: dataCall.CamId,
			iconCall: '1',
			enableBtnAssistedCall: dataCall.ExitAssistedDialMode,
			CallOutId:dataCall.CallOutId
		};
		this.phoneNumber = dataCall.PhoneNumber;
	}
	getDataAssistedCall() {
		return this.dataObject;
	}
	getIsEnableBtnExitAssited() {
		return this.dataObject.enableBtnAssistedCall;
	}
	getIsPendingMessage() {
		return this.isPendingMessage;
	}
	setIsPendingMessage(isPendingMessage) {
		this.isPendingMessage = isPendingMessage;
	}
	getSelectedConversationId() {
		return this.selectedConversationId;
	}
	setSelectedConversationId(conversationId) {
		this.selectedConversationId = conversationId;
	}
	getPrevNotificationError() {
		return this.prevNotificationError;
	}
	setPrevNotificationError(value) {
		this.prevNotificationError = value;
	}
	setDataPreviewPro(dialingMode, allowChangeDialMode) {
		this.dataPreviewPro = {
			dialingMode: dialingMode,
			allowChangeDialMode: allowChangeDialMode
		};
	}
	getDataPreviewPro() {
		return this.dataPreviewPro;
	}
	setDataCallPreview(data) {
		this.callDataPreviewPro = {
			CampaignName: data.CampaignName ? data.CampaignName : '',
			iconCampaing: data.GraphId ? data.GraphId : '',
			CamId: data.Cam_id,
			WrapUpTime: data.WrapUpTime,
			PreviewTime: data.previewTime,
			CallKey: data.CallKey ? data.CallKey : '',
			CallId: data.CallOut_id,
			Phone: data.Phone,
			DataContact: data.DataContact,
			DataHeaders: data.DataHeaders,
			PermissionDiscard: data.PermissionDiscard
		};
	}
	getDataCallPreview() {
		return this.callDataPreviewPro;
	}
	setIsInactiveState(isInactive) {
		this.isInactiveState = isInactive;
	}
	getIsInactiveState() {
		return this.isInactiveState;
	}
	setAudioNotificationCallStart(audio){
		this.audioNotificationCallStart = audio;
	}
	getAudioNotificationCallStart(){
		return this.audioNotificationCallStart;
	}
	setAudioNotificationCallEnd(audio){
		this.audioNotificationCallEnd = audio;
	}
	getAudioNotificationCallEnd(){
		return this.audioNotificationCallEnd;
	}
	setIsHangedUpByAgent(isHangedUp){
		this.isHangedUpByAgent = isHangedUp;
	}
	getIsHangedUpByAgent(){
		return this.isHangedUpByAgent;
	}
	setCallIcon(callIcon) {
        this.callIcon = callIcon;
    }
    getCallIcon() {
        return this.callIcon;
    }
	setIntegrationCallData(integrationCallData) {
        this.integrationCallData = integrationCallData;
    }
    getIntegrationCallData() {
        return this.integrationCallData;
    }
	setSendDataOncallout(send) {
        this.sendDataOncallout = send;
    }
    getSendDataOncallout() {
        return this.sendDataOncallout;
    }
	setAgentList(agentList) {
		this.agentList = agentList;
	}
	getAgentList() {
		return this.agentList;
	}
	setDoConnectCall(flag) {
		this.doConnectCall = flag;
	}
	getDoConnectCall() {
		return this.doConnectCall;
	}
	
}



// WEBPACK FOOTER //
// ./src/js/singletonSharedData.js